import * as React from 'react';
import { IPermissionOption } from '../../../../data/types';
import { ControlLabel } from '../ControlLabel';
import { Select } from '../Select';

interface IProps {
  teamId: string;
  value: IPermissionOption;
  onChange: (s: IPermissionOption) => void;
}

export const PermissionsSelect = (props: IProps): React.ReactElement => {
  const options: IPermissionOption[] = [
    {
      label: 'Team Administrator',
      value: {
        read: true,
        write: true,
        id: props.teamId,
      },
    },
    {
      label: 'Team User',
      value: {
        read: true,
        write: false,
        id: props.teamId,
      },
    },
  ];
  return (
    <div>
      <ControlLabel>User Type</ControlLabel>
      <Select
        name='user-type'
        options={options}
        placeholder='User Type...'
        controlShouldRenderValue={true}
        value={props.value}
        onChange={props.onChange}
        cache={false}
        id={'user-type'}
        isDisabled={!props.teamId}
      />
    </div>
  );
};
